import { render, staticRenderFns } from "./RemediationApplicationDetails.vue?vue&type=template&id=ca587e1e&scoped=true"
import script from "./RemediationApplicationDetails.vue?vue&type=script&lang=js"
export * from "./RemediationApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./RemediationApplicationDetails.vue?vue&type=style&index=0&id=ca587e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca587e1e",
  null
  
)

export default component.exports